<template>
  <manx-app-wrapper
    :page-title="pageTitle"
    :company-name="companyName"
    :on-logo-click="clickLogo"
    :show-widerruf-link="true"
  >
    <v-bottom-sheet v-model="alert.show" inset style="z-index: 1002" class="col-12">
      <v-sheet rounded elevation="4">
        <v-alert v-model="alert.show" dismissible :type="alert.type" @dismiss="alertClear">
          {{ alert.message }}
        </v-alert>
      </v-sheet>
    </v-bottom-sheet>
    <router-view class="col-12"></router-view>
    <v-overlay :value="loading" style="z-index: 1003">
      <v-progress-circular
        indeterminate
        color="primary"
        style="z-index: 1004"
      ></v-progress-circular>
    </v-overlay>

    <template v-slot:center-label>
      <span class="label">Gutachtenportal</span>
    </template>

    <template v-slot:navbar-right-side>
      <NavbarAccountActionsComponent />
    </template>

    <v-fab-transition>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-show="homeButton"
            color="green"
            dark
            absolute
            @click="clickHomeButton"
            right
            bottom
            value="Neue Bewertung"
            class="mb-15"
            fixed
            fab
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-file-document-plus-outline</v-icon>
          </v-btn>
        </template>
        <span>Zurück zur Gutachtenauswahl</span>
      </v-tooltip>
    </v-fab-transition>
  </manx-app-wrapper>
</template>

<script>
import { mapGetters } from 'vuex';
import NavbarAccountActionsComponent from '@/components/NavbarAccountActionsComponent';
import store from '@/store';

export default {
  name: 'App',
  components: { NavbarAccountActionsComponent },
  data() {
    return {
      alertMessage: undefined,
      messageType: 'error',
      showAlert: false,
      companyName: 'Sprengnetter Property Valuation Finance GmbH',
    };
  },
  computed: {
    ...mapGetters({
      username: 'user/username',
      pageTitle: 'pageTitle',
      homeButton: 'homeButton',
      alert: 'alert',
      loading: 'loading',
    }),
  },
  methods: {
    showError: function (msg) {
      this.alertMessage = msg;
      this.messageType = 'error';
      this.showAlert = true;
    },
    showInfo: function (msg) {
      this.alertMessage = msg;
      this.messageType = 'info';
      this.showAlert = true;
    },
    alertClear: function () {
      this.alertMessage = undefined;
      this.showAlert = false;
    },
    clickLogo() {
      this.$router.push('/gutachtenauswahl');
    },
    clickHomeButton() {
      store.dispatch('gutachten/reset');
      store.dispatch('objektbesichtigung/reset');
      store.dispatch('kaufpreisaufteilung/reset');
      store.dispatch('product/reset');
      store.dispatch('address/clearAddress').then();
      this.$router.push('/gutachtenauswahl');
    },
  },
  created() {
    this.$store.dispatch('loadLinks');
  },
};
</script>

<style>
@import '~@mdi/font/css/materialdesignicons.min.css';
@import '~leaflet/dist/leaflet.css';

.v-bottom-sheet.v-dialog.v-bottom-sheet--inset {
  box-shadow: none;
}

.v-card__actions {
  padding-left: 16px !important;
  padding-right: 16px !important;
}

.hide_scrollbar::-webkit-scrollbar {
  display: none;
}

.hide_NoChrome {
  overflow-y: hidden;
  overflow-x: visible;
  left: 20px !important;
  top: 57px !important;
}

.v-item-group.v-tabs-bar {
  height: 64px !important;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.scrollbar-measure {
  width: 100px;
  height: 100px;
  overflow: scroll;
  position: absolute;
  top: -9999px;
}

.v-menu__content {
  z-index: 1002 !important;
}

.multiline > span {
  width: 100%;
}

.full-height-flex {
  height: 100%;
  overflow: hidden;
  display: flex !important;
  align-items: stretch !important;
}

@media (max-width: 500px) {
  .dont-render-small {
    display: none;
  }
}

.textarea-max-height textarea {
  max-height: 7rem !important;
  overflow: auto !important;
}

.label {
  padding: 4px 8px;
  color: white;
  font-size: 1.5rem;
}

.label:hover {
  cursor: default;
}

.top-bar > span {
  margin-right: auto !important;
  margin-left: 5vw;
}

.v-text-field--filled .v-text-field__suffix {
  margin-top: 0 !important;
}

.v-input .v-label {
  line-height:  16px !important;
}

.v-text-field--outlined .v-label {
  top: 16px !important;
}
</style>
